// src/views/Legal/PrivacyPolicy.js
import React from "react";
import company from "../../config/company";

const PrivacyPolicy = () => {
  const effectiveDate = "12 de octubre de 2026";

  return (
    <div className="max-w-4xl mx-auto px-6 py-10 text-gray-800">
      <h1 className="text-3xl font-bold text-orange-600 mb-6">
        Política de Privacidad
      </h1>

      <p className="mb-4">
        Esta Política de Privacidad describe cómo {company.legalName} ("BBTS")
        recopila, usa, comparte y protege datos personales cuando utilizas
        nuestras soluciones digitales, incluyendo la aplicación{" "}
        {company.products.meso360} y las integraciones con Clover y con
        Dejavoo / iPOSpays.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        1. Información que recopilamos
      </h2>
      <p className="mb-4">
        Podemos recopilar datos de contacto del comercio (nombre, correo,
        teléfono), información operativa necesaria para prestar el servicio
        (por ejemplo pedidos, catálogos o estado de transacciones según los
        permisos autorizados en Clover) y datos técnicos mínimos de uso
        (registros, diagnóstico, seguridad).
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        2. Uso de la información
      </h2>
      <p className="mb-4">
        Usamos la información para operar la aplicación, brindar soporte,
        mantener seguridad, mejorar funcionalidades y cumplir obligaciones
        legales/contractuales. No usamos datos del comercio para finalidades no
        autorizadas por el comercio o por la ley.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        3. Cómo compartimos información
      </h2>
      <p className="mb-4">
        Podemos compartir datos con: (a) Clover/Fiserv y Dejavoo/iPOSpays,
        según la integración que use el comercio; (b) proveedores tecnológicos
        que nos ayudan a operar el servicio (infraestructura, correo
        electrónico, SMS y WhatsApp, analítica); y (c) autoridades cuando
        exista obligación legal. No vendemos datos personales.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        4. Pagos con tarjeta
      </h2>
      <p className="mb-4">
        BBTS no es un procesador de pagos. Los pagos con tarjeta los procesan
        Clover/Fiserv o Dejavoo/iPOSpays en sus propias terminales y
        aplicaciones de pago. Cuando una venta se cobra desde{" "}
        {company.products.meso360}, guardamos solo lo necesario para cuadrar la
        cuenta del restaurante: estado de la transacción, referencias, número
        de autorización y de lote, marca de la tarjeta, últimos cuatro dígitos,
        montos, propina, cargos e impuestos.{" "}
        <strong>
          No guardamos el número completo de la tarjeta, el código de
          seguridad (CVV), la fecha de vencimiento, el nombre del titular, la
          firma, los datos del chip (EMV) ni los tokens de pago.
        </strong>
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        5. Aplicación {company.products.meso360}
      </h2>
      <p className="mb-4">
        {company.products.meso360} es la aplicación de BBTS para la operación
        de restaurantes (mesas, órdenes, cobro, cocina y pantallas). Para
        funcionar, trata estos datos:
      </p>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>
          Del personal del restaurante: nombre, correo electrónico, rol y
          permisos. El PIN de acceso rápido y las contraseñas se guardan
          cifrados y nunca se pueden leer.
        </li>
        <li>
          Códigos de acceso de un solo uso que enviamos por correo para entrar
          al panel web, que vencen a los pocos minutos.
        </li>
        <li>
          Datos de la operación: mesas, órdenes, pagos y cierres de lote, según
          lo descrito en la sección anterior.
        </li>
        <li>
          La cámara del equipo, solo para escanear códigos QR (conectar la app
          con el servidor del restaurante o enlazar pantallas). No tomamos ni
          guardamos fotos sin que la persona lo haga a propósito, por ejemplo
          al subir la foto de un plato.
        </li>
      </ul>
      <p className="mb-4">
        Los recibos electrónicos de una venta con tarjeta los envía el
        procesador (Dejavoo/iPOSpays) al correo o teléfono que indique el
        cliente.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        6. Seguridad y retención
      </h2>
      <p className="mb-4">
        Implementamos medidas técnicas y organizativas razonables para proteger
        la información contra acceso no autorizado, alteración o pérdida.
        Conservamos los datos solo por el tiempo necesario para prestar el
        servicio, cumplir obligaciones legales y resolver disputas.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        7. Tus derechos y opciones
      </h2>
      <p className="mb-4">
        Puedes solicitar acceso, corrección o eliminación de datos, sujeto a la
        ley aplicable y a nuestras obligaciones contractuales. Si eres cliente
        de un comercio que usa nuestras soluciones, también puedes dirigir tu
        solicitud al comercio correspondiente.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">8. Contacto</h2>
      <p className="mb-4">
        Si tienes preguntas sobre esta política, escríbenos a{" "}
        <a className="text-orange-700 underline" href={`mailto:${company.email}`}>
          {company.email}
        </a>
        , llámanos al{" "}
        <a className="text-orange-700 underline" href={company.phoneHref}>
          {company.phone}
        </a>{" "}
        o visita nuestra página de{" "}
        <a className="text-orange-700 underline" href="/contact">
          soporte
        </a>
        .
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">9. Cambios</h2>
      <p className="mb-4">
        Podemos actualizar esta Política de Privacidad. Publicaremos la versión
        vigente en esta misma página con la fecha de actualización.
      </p>

      <p className="text-sm text-gray-500 mt-8">
        Última actualización: {effectiveDate}
      </p>
    </div>
  );
};

export default PrivacyPolicy;
